
// List of all PublicAF module Selectors
export const getDefaultFilters = ({ publicAFList }) => publicAFList.searchFilter;
export const getListPageTitle = ({ publicAFList }) => publicAFList.searchLabel;
export const getListAlertModal = ({ publicAFList }) => publicAFList.alert;
export const getListConfirmModal = ({ publicAFList }) => publicAFList.confirmModal;

// Table Selectors
export const getTableData = ({ publicAFList }) => publicAFList.resultTable.data;
export const getTableSelectedRows = ({ publicAFList }) => publicAFList.resultTable.selectedRows;
export const getTotalCount = ({ publicAFList }) => publicAFList.resultTable.totalCount;
export const getCurrentPage = ({ publicAFList }) => publicAFList.searchFilter.Pagination.Page;
export const getSortModel = ({ publicAFList }) => publicAFList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ publicAFList }) => publicAFList.resultTable.rowsPerPage;
export const isTableLoading = ({ publicAFList }) => publicAFList.resultTable.loading;
export const getListAlertModelData = ({ publicAFList }) => publicAFList.alert;

// PublicAF Add Form
export const getAddFormData = ({ publicAFAdd }) => publicAFAdd.addForm;
export const getAlertModelData = ({ publicAFAdd }) => publicAFAdd.alert;
export const getShowLoading = ({ publicAFAdd }) => publicAFAdd.loading;
export const getDisclaimerData = ({ publicAFAdd }) => publicAFAdd.disclaimer;
export const getFileUploadData = ({ publicAFAdd }) => publicAFAdd.fileUpload;
export const getAgeData = ({ publicAFAdd }) => publicAFAdd.age;
export const getAddEmailTemplate = ({ publicAFAdd }) => publicAFAdd.emailTemplate;

// PublicAF Detail Form
export const hasLoadedData = ({ publicAFDetails }) => publicAFDetails.hasLoadedData;
export const getFormTitle = ({ publicAFDetails }) => publicAFDetails.title;
export const getDetailData = ({ publicAFDetails }) => publicAFDetails.detailForm;
export const getEditable = ({ publicAFDetails }) => publicAFDetails.isEditable;
export const getDetailMode = ({ publicAFDetails }) => publicAFDetails.mode;
export const getDetailAlertModal = ({ publicAFDetails }) => publicAFDetails.alert;
export const getDetailConfirmModal = ({ publicAFDetails }) => publicAFDetails.confirmModal;
export const getAttachmentData = ({ publicAFDetails }) => publicAFDetails.curriculumVitae;
export const getApplicantView = ({ publicAFDetails }) => publicAFDetails.isApplicantView;
export const getDetailFileUploadData = ({ publicAFDetails }) => publicAFDetails.fileUpload;
export const getDetailEmailTemplate = ({ publicAFDetails }) => publicAFDetails.emailTemplate;

export const validateEmployeeId = (employeeId) => {
    if (employeeId.trim() === '') {
        return 'Employee ID is required!';
    }
    return '';
};

export const validateAddForm = (values) => {
    let errors = {};

    if (values.firstName.trim() === '') {
        errors[`firstName`] = 'First Name is required!'
    }

    if (values.lastName.trim() === '') {
        errors[`lastName`] = 'Last Name is requried!'
    }

    if (values.age === '') {
        errors[`age`] = 'Age is requried!'
    }

    if (values.cityAddress.trim() === '') {
        errors[`cityAddress`] = 'City Address is required!'
    }

    if (values.contactNumber.trim() === '') {
        errors.contactNumber = 'Contact number is required!';
    }
    else if (!/^(?:\+?63|0)[\s.-]?(\d{3})[\s.-]?(\d{3})[\s.-]?(\d{4})$/.test(values.contactNumber.trim())) {
        errors.contactNumber = 'Please enter a valid Philippine mobile number.';
    }

    if (values.provincialAddress.trim() === '') {
        errors[`provincialAddress`] = 'Provincial Address is required!'
    }

    if (values.provincialContactNumber.trim() === '') {
        errors[`provincialContactNumber`] = 'Pronvincial Contact Number is required!'
    }
    else if (!/^(?:\+?63|0)[\s.-]?(\d{3})[\s.-]?(\d{3})[\s.-]?(\d{4})$/.test(values.provincialContactNumber.trim())) {
        errors.provincialContactNumber = 'Please enter a valid Philippine mobile number.';
    }

    if (values.civilStatus === -1) {
        errors[`civilStatus`] = 'Civil Status is required!'
    }

    if (values.emailAddress.trim() === '') {
        errors[`emailAddress`] = 'Email Address is required!'
    }
    else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(values.emailAddress.trim())) {
        errors.emailAddress = 'Please enter a valid email address.';
    }

    if (values.curriculumVitae.length === 0) {
        errors[`curriculumVitae`] = 'Required to attach a Resume/Curicullum Vitae!'
    }

    if (isNaN(values.jobSource) || values.jobSource === 0) {
        errors[`jobSource`] = 'Job Source is required to field!'
    }

    let others = 17
    if (values.others.trim() === '' && values.jobSource === others) {
        errors[`others`] = 'Job Source is required to field!'
    }

    if (isNaN(values.availableJob) || values.availableJob === 0) {
        errors[`availableJob`] = 'Select Available Jobs is required'
    }

    if (values.skills.length === 0) {
        errors[`skills`] = 'Skills is required to field!'
    }

    let workExperienceErrors = [];

    values.workExperience.forEach((item) => {
        const isRowFilled = Object.values(item).some(val => val !== null && val !== '');

        if (isRowFilled) {
            if (item.companyName === null || item.companyName.trim() === '') {
                workExperienceErrors.push(`Company`);
            }

            if (item.position === null || item.position.trim() === '') {
                workExperienceErrors.push(`Position`);
            }

            if (item.reason === null || item.reason.trim() === '') {
                workExperienceErrors.push(`Reason`);
            }
        }
    });

    if (workExperienceErrors.length > 0) {
        errors[`workExperience`] = `Please fill out the following required fields: ${workExperienceErrors.join(', ')}.`;
    }

    if (values.educationalBackground.length < 3) {
        errors[`educationalBackground`] = 'Must be at least 3 Educational Background!';
    } else {
        let educationalErrors = new Set();

        values.educationalBackground.forEach((item) => {
            const isRowFilled = Object.values(item).some(val => val !== null && val !== '');

            if (isRowFilled) {
                if (item.educationLevel === null) {
                    educationalErrors.add('Education Level');
                }

                if (
                    item.educationLevel === -1 &&
                    (item.otherEducationLevel === null ||
                        item.otherEducationLevel === undefined ||
                        item.otherEducationLevel.trim() === '')
                ) {
                    educationalErrors.add('Education Level');
                }

                if (item.schoolName === null) {
                    educationalErrors.add('School Name');
                }

                if (
                    item.schoolName === 1 &&
                    (item.otherSchoolName === null ||
                        item.otherSchoolName === undefined ||
                        item.otherSchoolName.trim() === '')
                ) {
                    educationalErrors.add('School Name');
                }

                if (
                    item.schoolAddress === null ||
                    item.schoolAddress === undefined ||
                    item.schoolAddress.trim() === ''
                ) {
                    educationalErrors.add('School Address');
                }

                if (
                    item.course === null ||
                    item.course === undefined ||
                    item.course.trim() === ''
                ) {
                    educationalErrors.add('Course');
                }
            }
        });

        if (educationalErrors.size > 0) {
            errors[`educationalBackground`] = `Please fill out the following required fields: ${Array.from(educationalErrors).join(', ')}.`;
        }
    }

    if (values.characterReference.length < 3) {
        errors[`characterReference`] = 'Must be at least 3 Character References!';
    } else {
        let characterErrors = new Set();

        values.characterReference.forEach((item, index) => {
            const isRowFilled = Object.values(item).some(val => val !== null && val !== '');

            if (isRowFilled) {
                if (item.characterName === null || item.characterName.trim() === '') {
                    characterErrors.add(`Name`);
                }

                if (item.company === null || item.company.trim() === '') {
                    characterErrors.add(`Company`);
                }

                if (item.position === null || item.position.trim() === '') {
                    characterErrors.add(`Position`);
                }

                if (item.relationship === null || item.relationship.trim() === '') {
                    characterErrors.add(`Relationship`);
                }

                if (item.characterEmailAddress === null || item.characterEmailAddress.trim() === '') {
                    characterErrors.add(`Email Address`);
                } else if (
                    item.characterEmailAddress &&
                    !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(item.characterEmailAddress.trim())
                ) {
                    characterErrors.add(`Invalid Email Address`);
                }

                if (item.characterContactNumber === null || item.characterContactNumber.trim() === '') {
                    characterErrors.add(`Contact Number`);
                } else if (
                    item.characterContactNumber &&
                    !/^(?:\+?63|0)[\s.-]?(\d{3})[\s.-]?(\d{3})[\s.-]?(\d{4})$/.test(item.characterContactNumber.trim())
                ) {
                    characterErrors.add(`Invalid Contact Number`);
                }
            }
        });

        if (characterErrors.size > 0) {
            errors[`characterReference`] = `Please fill out the following required fields: ${Array.from(characterErrors).join(', ')}.`;
        }
    }

    // Work Experience
    if (!values.canSubmitWE) {
        if (values.companyName === '') {
            errors[`companyName`] = 'Company Name is Required!'
        }

        if (values.position === '') {
            errors[`position`] = 'Position is Required!'
        }

        if (values.dateFrom === null) {
            errors[`dateFrom`] = 'Date From is Required!'
        }

        if (values.dateTo === null) {
            errors[`dateTo`] = 'Date To is Required!'
        }

        if (values.reason === '') {
            errors[`reason`] = 'Reason is Required!'
        }
    }

    // Educational Background
    if (!values.canSubmitEB) {
        if (values.educationLevel === null) {
            errors[`educationLevel`] = 'Education Level is required!'
        }

        if (values.educationLevel === -1 && values.otherEducationLevel === '') {
            errors[`otherEducationLevel`] = 'Other Education Level is required!'
        }

        if (values.schoolName === null) {
            errors[`schoolName`] = 'School Name is required!'
        }

        if (values.schoolName === 1 && values.otherSchoolName === '') {
            errors[`otherSchoolName`] = 'Other School Name is required!'
        }

        if (values.schoolAddress === '') {
            errors[`schoolAddress`] = 'School Address is required!'
        }

        if (values.course === '') {
            errors[`course`] = 'Course is required!'
        }

        if (values.dateCompleted === null) {
            errors[`dateCompleted`] = 'Date is required!'
        }
    }

    // Character Reference
    if (!values.canSubmitCB) {
        if (values.characterName === '') {
            errors[`characterName`] = 'Character Name is required!'
        }

        if (values.charCompany === '') {
            errors[`charCompany`] = 'Character Company is required!'
        }

        if (values.charPosition === '') {
            errors[`charPosition`] = 'Character Position is required!'
        }

        if (values.relationship === '') {
            errors[`relationship`] = 'Relationship is required!'
        }

        if (values.characterEmailAddress === '') {
            errors[`characterEmailAddress`] = 'Character Email Address is required!'
        }
        else if (values.characterEmailAddress && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
            values.characterEmailAddress.trim())) {
            errors.characterEmailAddress = 'Please enter a valid email address.';
        }

        if (values.characterContactNumber === '') {
            errors[`characterContactNumber`] = 'Character Contact is required!'
        }
        else if (values.characterContactNumber && !/^(?:\+?63|0)[\s.-]?(\d{3})[\s.-]?(\d{3})[\s.-]?(\d{4})$/.test(
            values.characterContactNumber.trim())) {
            errors.characterContactNumber = 'Please enter a valid Philippine mobile number.';
        }
    }

    return errors;
}

